<div mat-dialog-content>
  <p>
    Êtes-vous sûr de vouloir valider ces inventaires ?
  </p>
  <p>
    Après confirmation, ils ne seront plus modifiables.
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()" color="white">Annuler</button>
  <button mat-raised-button color="primary" (click)="validate()">Confirmer</button>
</div>